<div class="url-field">
  <a href="{{ field().url }}" target="_blank" mat-stroked-button
    >{{ field().label }} <mat-icon iconPositionEnd>open_in_new</mat-icon></a
  >
</div>
